import { render, staticRenderFns } from "./BuyFromOutsource.vue?vue&type=template&id=3b721884&"
import script from "./BuyFromOutsource.vue?vue&type=script&lang=js&"
export * from "./BuyFromOutsource.vue?vue&type=script&lang=js&"
import style0 from "./BuyFromOutsource.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports